import { useQuery } from 'react-query'
import { request } from 'Features/auth/axios-client'

const fetchConstrainedData = async (
  planId: string,
  sourcesiteId: string,
  workcentreId: string,
  selectedSku: string | null
) => {
  const queryString = selectedSku ? `?selectedSku=${selectedSku}` : ''
  const { data } = await request({
    url: `/stockbuild/plan/${planId}/source-sites/${sourcesiteId}/workcentres/${workcentreId}/capacity-graph${queryString}`,
  })
  return data
}

export const useConstrainedData = (
  planId: string,
  sourcesiteId: string,
  workcentreId: string,
  selectedSku: string | null
) => {
  return useQuery(
    ['constrained-graph-data', planId, sourcesiteId, workcentreId, selectedSku],
    () => fetchConstrainedData(planId, sourcesiteId, workcentreId, selectedSku),
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      select: (data) => data?.data ?? [],
      cacheTime: 0,
    }
  )
}

const fetchTableData = async (
  planId: string,
  sourcesiteId: string,
  workcentreId: string
) => {
  const { data } = await request({
    url: `/stockbuild/plan/${planId}/source-sites/${sourcesiteId}/workcentres/${workcentreId}/stock-build-table`,
  })
  return data
}

export const useTableData = (
  planId: string,
  sourcesiteId: string,
  workcentreId: string
) => {
  return useQuery(
    ['stock-build-table', planId, sourcesiteId, workcentreId],
    () => fetchTableData(planId, sourcesiteId, workcentreId),
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      select: ({ data }) => {
        return data
      },
      cacheTime: 0,
    }
  )
}

const fetchExcessData = async (
  planId: string,
  sourcesiteId: string,
  workcentreId: string,
  selectedSku: string | null
) => {
  const queryString = selectedSku ? `?selectedSku=${selectedSku}` : ''
  const { data } = await request({
    url: `/stockbuild/plan/${planId}/source-sites/${sourcesiteId}/workcentres/${workcentreId}/excess-graph${queryString}`,
  })
  return data
}

export const useExcessData = (
  planId: string,
  sourcesiteId: string,
  workcentreId: string,
  selectedSku: string | null
) => {
  return useQuery(
    ['stock-build-excess', planId, sourcesiteId, workcentreId, selectedSku],
    () => fetchExcessData(planId, sourcesiteId, workcentreId, selectedSku),
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      select: (data) => data?.data ?? [],
      cacheTime: 0,
    }
  )
}
